<template>
  <div class="pox">
    <div class="pox_box">
      <p class="p_title">无线传感器系列</p>
      <div class="motherMenu">
        <div
          class="motherMenu-box"
          v-for="(item, index) in titname"
          :key="index"
        >
          {{ item.name }}
          <i
            v-if="brType == item.id"
            class="el-icon-arrow-down"
            @click="handelbrType(0)"
          ></i>
          <i v-else class="el-icon-arrow-up" @click="handelbrType(item.id)"></i>
        </div>
      </div>
      <div class="meun_box" v-for="(item1, index1) in meunone" :key="index1">
        <div :class="[brType == item1.brnum ? 'menu' : 'menu1']">
          <div v-for="(item2, index2) in item1.proList" :key="index2">
            <p
              :class="[btnType == item2.num ? 'p2' : 'p1']"
              @click="choseType(item2.num)"
            >
              {{ item2.name }}
            </p>
          </div>
        </div>
      </div>

      <!-- <p class="p_title1" v-if="btnType == 0 || btnType == 2">
        无线温度变送器<span></span>
      </p>
      <p class="p_title1" v-if="btnType == 1 || btnType == 3">
        无线压力变送器<span></span>
      </p>
      <p class="p_title1" v-if="btnType == 4">无线液位变送器<span></span></p> -->
      <!-- <div class="left_dh">
        <div
          :class="[btnType == 0 ? 'div_dh' : 'div_dh1']"
          @click="choseType(0)"
        >
          YCT001
        </div>
        <div
          :class="[btnType == 1 ? 'div_dh' : 'div_dh1']"
          @click="choseType(1)"
          style="margin-left: 1.61458vw"
        >
          YCT011
        </div>
        <div
          :class="[btnType == 2 ? 'div_dh' : 'div_dh1']"
          @click="choseType(2)"
          style="margin-left: 1.61458vw"
        >
          YCT002
        </div>
        <div
          :class="[btnType == 3 ? 'div_dh' : 'div_dh1']"
          @click="choseType(3)"
          style="margin-left: 1.61458vw"
        >
          YCT022
        </div>
        <div
          :class="[btnType == 4 ? 'div_dh' : 'div_dh1']"
          @click="choseType(4)"
          style="margin-left: 1.61458vw"
        >
          YCT052
        </div>
      </div> -->
      <div class="cen_box">
        <div class="box_left">
          <div v-if="btnType == 1" class="left_img">
            <img src="../../../assets/imgs/nbht/xcg1.png" alt="" />
          </div>
          <div v-if="btnType == 2 || btnType == 3" class="left_img">
            <img src="../../../assets/imgs/nbht/xcg3.png" alt="" />
          </div>
          <div v-if="btnType == 4" class="left_img">
            <img src="../../../assets/imgs/nbht/xcg2.png" alt="" />
          </div>
          <div v-if="btnType == 5 || btnType == 6" class="left_img">
            <img src="../../../assets/imgs/nbht/xcg4.png" alt="" />
          </div>
          <div v-if="btnType == 7 || btnType == 8" class="left_img">
            <img src="../../../assets/imgs/nbht/xcg5.png" alt="" />
          </div>
          <div v-if="btnType == 9 || btnType == 10" class="left_img">
            <img src="../../../assets/imgs/nbht/xwg1.png" alt="" />
          </div>
        </div>
        <div class="box_rig">
          <div class="rig_title">
            <div class="rig_ic"></div>
            <div class="rig_size">功能特点</div>
          </div>
          <div class="rig_cen" style="margin-bottom: 1.25vw">
            <ul v-for="(item, index) in list" :key="index">
              <li>
                {{ item.data }}
              </li>
            </ul>
          </div>
          <div class="rig_title">
            <div class="rig_ic1"></div>
            <div class="rig_size">应用场景</div>
          </div>
          <div class="rig_cen">
            <ul v-for="(item, index) in listdata" :key="index">
              <li>
                {{ item.data }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titname: [
        {
          id: 1,
          name: "无线温度变送器",
        },
        {
          id: 2,
          name: "无线压力变送器",
        },
        {
          id: 3,
          name: "无线液位变送器",
        },
        {
          id: 4,
          name: "数字量转WiFi",
        },
      ],
      meunone: [
        {
          brnum: 1,
          proList: [
            { name: "YC-ST-01W", num: 1 },
            { name: "YC-ST-11W", num: 2 },
            { name: "YC-ST-12W", num: 3 },
          ],
        },
        {
          brnum: 2,
          proList: [
            { name: "YC-SP-01W", num: 4 },
            { name: "YC-SP-11W", num: 5 },
            { name: "YC-SP-12W", num: 6 },
          ],
        },
        {
          brnum: 3,
          proList: [
            { name: "YC-SL-01W", num: 7 },
            { name: "YC-SL-02W", num: 8 },
          ],
        },
        {
          brnum: 4,
          proList: [
            { name: "YC-SS-01W", num: 9 },
            { name: "YC-SS-02W", num: 10 },
          ],
        },
      ],
      listtit: [
        { name: "YCMD51(主)", code: 0 },
        { name: "YCMD41(从)", code: 1 },
        { name: "YCMD11", code: 2 },
      ],
      list: [
        { data: "输入电源 DC24V，无线 WiFi 或 4G 传输实时数据，组网方便" },
        { data: "可选 STA 模式，私有协议通讯，信息加密，传输安全性强" },
        {
          data: "可选 AP 模式，遵循 modbus-tcp 通讯协议，扩展性强，灵活接入现有 modbus-tcp 网络",
        },
        { data: "体积小，稳定性好，抗干扰能力强，安全性高" },
      ],
      listdata: [{ data: "设备或管道温度检测" }],
      activeIndex: "1",
      btnType: 1,
      brType: 0,
    };
  },
  inject: ["reload"],
  watch: {},
  // 组件初始化
  created() {},
  // 组件实例挂载完毕
  mounted() {},

  destroyed() {},
  // 组件方法
  methods: {
    handelbrType(brtype) {
      console.log(brtype);
      this.brType = brtype;
    },
    choseType(type) {
      this.btnType = type;
      if (type == 1) {
        this.list = [
          { data: "输入电源 DC24V，无线 WiFi 或 4G 传输实时数据，组网方便" },
          { data: "可选 STA 模式，私有协议通讯，信息加密，传输安全性强" },
          {
            data: "可选 AP 模式，遵循 modbus-tcp 通讯协议，扩展性强，灵活接入现有 modbus-tcp 网络",
          },
          { data: "体积小，稳定性好，抗干扰能力强，安全性高" },
        ];
        this.listdata = [{ data: "设备或管道温度检测" }];
      } else if (type == 2 || type == 3) {
        this.list = [
          { data: "输入电源 DC24V，无线 WiFi 或 4G 传输实时数据，组网方便" },
          { data: "可选 STA 模式，私有协议通讯，信息加密，传输安全性强" },
          {
            data: "可选 AP 模式，遵循 modbus-tcp 通讯协议，扩展性强，灵活接入现有 modbus-tcp 网络",
          },
          {
            data: "稳定性好，抗干扰能力强，安全性高 , 机械强度高，测量范围广，反应速度快，动态误差小",
          },
        ];
        this.listdata = [{ data: "设备或管道温度检测" }];
      } else if (type == 4) {
        this.list = [
          { data: "输入电源 DC24V，无线 WiFi 或 4G 传输实时数据，组网方便" },
          { data: "可选 STA 模式，私有协议通讯，信息加密，传输安全性强" },
          {
            data: "可选 AP 模式，遵循 modbus-tcp 通讯协议，扩展性强，灵活接入现有 modbus-tcp 网络",
          },
          {
            data: "体积小，稳定性好，抗干扰能力强，安全性高",
          },
        ];
        this.listdata = [{ data: "设备或管道压力检测" }];
      } else if (type == 5 || type == 6) {
        this.list = [
          { data: "输入电源 DC24V，无线 WiFi 或 4G 传输实时数据，组网方便" },
          { data: "可选 STA 模式，私有协议通讯，信息加密，传输安全性强" },
          {
            data: "可选 AP 模式，遵循 modbus-tcp 通讯协议，扩展性强，灵活接入现有 modbus-tcp 网络",
          },
          {
            data: "稳定性好，抗干扰能力强，安全性高 , 机械强度高，测量范围广，反应速度快，动态误差小",
          },
        ];
        this.listdata = [{ data: "设备或管道压力检测" }];
      } else if (type == 7 || type == 8) {
        this.list = [
          { data: "输入电源 DC24V，无线 WiFi 或 4G 传输实时数据，组网方便" },
          { data: "可选 STA 模式，私有协议通讯，信息加密，传输安全性强" },
          {
            data: "可选 AP 模式，遵循 modbus-tcp 通讯协议，扩展性强，灵活接入现有 modbus-tcp 网络",
          },
          {
            data: "稳定性好，抗干扰能力强，安全性高 , 机械强度高，测量范围广，反应速度快，动态误差小",
          },
        ];
        this.listdata = [{ data: "水箱水位液位检测" }];
      } else if (type == 9 || type == 10) {
        this.list = [
          { data: "4 路数字量输出，每路含常开、常闭（5A）" },
          { data: "6 路数字量输入，支持干节点和湿节点" },
          {
            data: "1 路无极性 485 通讯",
          },
          {
            data: "1 个扩展位，可以扩展 wifi，4G，Lora 等",
          },
          {
            data: "多种协议：TCP/UDP/MQTT/DHCP",
          },
          {
            data: "工作状态指示、看门狗故障复位。",
          },
        ];
        this.listdata = [{ data: "工业物联网、农业物联网等领域，开关量控制，如：水泵、电机、灯具、电动阀等。" }];
      }
    },
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
      this.$router.push(key);
    },
  },
};
</script>

<style scoped lang="less">
.meun_box:nth-child(4) {
  margin-left: 198px;
}
.meun_box:nth-child(5) {
  margin-left: 396px;
}
.meun_box:nth-child(6) {
  margin-left: 594px;
}
.menu {
  position: absolute;
  .p1 {
    height: 51px;
    width: 158px;
    background-color: rgba(26, 38, 64, 0.6);
    line-height: 51px;
    color: rgba(177, 177, 177, 1);
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
  }
  .p2 {
    height: 51px;
    width: 158px;
    background-color: rgba(26, 38, 64, 0.6);
    line-height: 51px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
  }
}

.menu1 {
  display: none;
}
i {
  text-indent: 8px;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
}
.motherMenu {
  width: 800px;
  height: 28px;
  // border: 1px solid gold;
  margin-top: 18px;
  display: flex;
  user-select: none;
  .motherMenu-box {
    width: 158px;
    height: 100%;
    // border: 1px solid green;
    margin-left: 40px;
    // text-align: center;
    line-height: 28px;
    color: rgba(61, 72, 93, 1);
    font-weight: 600;
    font-size: 18px;
  }
  .motherMenu-box:nth-child(1) {
    margin-left: 0px;
  }
}
.pox {
  width: 100%;
  height: 100%;
  .pox_box {
    width: 100%;
    height: 100%;
    padding: 32px;
    .p_title {
      width: 70%;
      height: 42px;
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #1b1e20;
      line-height: 42px;
    }
    // .p_title1 {
    //   width: 70%;
    //   height: 48px;
    //   font-size: 18px;
    //   font-family: PingFangSC, PingFang SC;
    //   font-weight: 600;
    //   color: #3d485d;
    //   line-height: 48px;
    //   // margin-left: 24px;
    //   margin-top: 8px;
    //   span {
    //     color: #d8d8d8;
    //   }
    // }
    // .left_dh {
    //   width: 100%;
    //   height: 38px;
    //   font-size: 18px;
    //   margin-top: 8px;
    //   //border: 1px solid gray;
    //   display: flex;
    //   .div_dh {
    //     width: 66px;
    //     height: 38px;
    //     line-height: 38px;
    //     color: #0072ff;
    //     text-align: center;
    //     font-weight: 500;
    //     border-bottom: 3px solid #0072ff;
    //     cursor: pointer;
    //   }
    //   .div_dh1 {
    //     width: 66px;
    //     height: 38px;
    //     line-height: 38px;
    //     color: #b1b1b1;
    //     text-align: center;
    //     cursor: pointer;
    //     // font-weight: 600;
    //     //border-bottom: 3px solid #0072ff;
    //   }
    // }
    .cen_box {
      width: 100%;
      // height: 300px;
      // border: 1px solid gold;
      margin-top: 75px;
      display: flex;
      .box_left {
        width: 400px;
        // height: 300px;
        // margin-left: 24px;
        // border: 1px solid gray;
        .left_img {
          width: 400px;
          height: 300px;
          // margin:0 auto;
          // margin-left: 100px;
          // margin-top: 36px;
          // border: 1px solid goldenrod;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .box_rig {
        width: 407px;
        // border: 1px solid gray;
        margin-left: 160px;
        .rig_title {
          width: 100%;
          height: 24px;
          // border: 1px solid gold;
          display: flex;
          margin-left: -26px;
          .rig_ic {
            width: 24px;
            height: 24px;
            // margin-top: 5px;
            background-image: url("../../../assets/imgs/ycic11.png");
            background-size: 100% 100%;
            // border: 1px solid gray;
          }
          .rig_ic1 {
            width: 24px;
            height: 24px;
            // margin-top: 5px;
            background-image: url("../../../assets/imgs/ycic22.png");
            background-size: 100% 100%;
            // border: 1px solid gray;
          }
          .rig_size {
            width: 70%;
            height: 24px;
            margin-left: 8px;
            line-height: 24px;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #1b1e20;
            line-height: 24px;
          }
        }
        .rig_cen {
          width: 100%;
          margin-top: 8px;

          ul li {
            padding-left: 6px;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #3d485d;
            line-height: 28px;
          }
        }
        .rig_tit2 {
          width: 100%;
          height: 24px;
          // border: 1px solid goldenrod;
          margin-top: 28px;
        }
        .rig_cen {
          width: 100%;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
